// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__as_eg","vLegacy":"SelectSecondary_vLegacy__14GuA","error":"SelectSecondary_error__2CdBg","disabled":"SelectSecondary_disabled__19QDd"};